(function () {
  'use strict';

  // Label and POI clutter off, plus the desaturated, darkened treatment
  // from the design. This runs through the Maps style API rather than a
  // CSS filter on the container, because a filter there would dim the
  // Google logo and attribution along with the map, and Google's terms
  // require those to stay legible.
  const MAP_STYLE = [
    { stylers: [{ saturation: -100 }, { lightness: -58 }] },
    { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [{ visibility: 'off' }],
    },
    { featureType: 'poi', stylers: [{ visibility: 'off' }] },
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
  ];

  function initMap(element) {
    const lat = parseFloat(element.dataset.lat);
    const lng = parseFloat(element.dataset.lng);

    if (Number.isNaN(lat) || Number.isNaN(lng)) {
      return;
    }

    const center = { lat: lat, lng: lng };

    new google.maps.Map(element, {
      center: center,
      zoom: parseInt(element.dataset.zoom, 10) || 11,
      styles: MAP_STYLE,
      disableDefaultUI: true,
      keyboardShortcuts: false,
      clickableIcons: false,
      gestureHandling: 'none',
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof google === 'undefined' || !google.maps) {
      return;
    }

    document.querySelectorAll('.js-map').forEach(initMap);
  });
})();
